import {useEffect, useRef, useState} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {useIntl} from 'react-intl'
import 'swiper/css'
import 'swiper/css/pagination'
import '../styles/layout.scss'
import {auto} from '@popperjs/core'
import AuthSwiper from './AuthSwiper'
import AuthLadingPage from './AuthLandingPage'
import brandingConfig from '../../../../../config/brandingConfig'
import RecordsKeeperAuthLandingPage from './AuthLandingPageRK'
import {authData} from './AuthLandingPageData'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../../hooks/gtmHelpers'

export const Layout = () => {
  const {formatMessage} = useIntl()
  const {pathname}: any = useLocation()
  const FinanceData = authData.finance
  const LegalData = authData.legal
  const GovData = authData.gov
  const HealthcareData = authData.heatlcare
  const path = pathname.includes('/public-request-file') ? '/public-request-file' : pathname
  const mounted = useRef(false)
  const Host = window.location.host
  const protocol = window.location.protocol
  const registrationUrl = Host.includes('localhost')
    ? `/auth/registration/?lp=generic&utm_source=recordskeeper.ai&utm_medium=web-app&utm_campaign=file-download-page`
    : `${protocol}//${Host}/auth/registration/?lp=generic&utm_source=recordskeeper.ai&utm_medium=web-app&utm_campaign=file-download-page`

  const pathArray = [
    '/terms-of-use',
    '/privacy-policy',
    '/meeting-invite',
    '/public-request-file',
    '/onboarding/',
    '/onboarding/company-details',
    '/onboarding/initialize-round',
    '/onboarding/team-members',
    '/public-query-details',
  ]

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  // Handle invite acceptance
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const lp = searchParams.get('lp')

  const currentYear = new Date().getFullYear()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    if (lp && !mounted.current && path === '/auth/registration') {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.LandingPageViewSuccessful,
          metadata: {
            landing_page: lp,
          },
        },
      })
      mounted.current = true
    }
  }, [lp]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    // Set initial state based on the window width
    handleResize()

    // Add event listener to handle window resize
    window.addEventListener('resize', handleResize)

    // Cleanup on component unmount
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <>
      {pathArray.includes(path) ? (
        <div
          className={
            // pathArray.includes(path)
            //   ? `founder-crate-background `
            //   : 'founder-crate-bg founder-crate-background'
            `d-flex align-items-center h-100 p-4`
          }
        >
          {/* begin::Body */}
          <div className='align-items-md-center col-12 d-md-flex flex-md-column h-100'>
            {/* <div className='founder-create-logo d-flex justify-content-center mb-8'>
              <img src={toAbsoluteUrl('/media/auth/founderCrateLogo.svg')} alt='Logo' />
            </div> */}
            <div className='founder-create-logo d-flex justify-content-center mb-4'>
              <a href={registrationUrl} target='_blank' rel='noreferrer'>
                <img src={toAbsoluteUrl(brandingConfig.lightModeLogo)} alt='Logo' width={280} />
              </a>
            </div>
            {/* begin::Form */}
            <div
              className={`d-flex flex-column px-6 px-md-0 ${
                pathArray.includes(path) ? 'col-md-10' : 'col-3-5'
              }`}
              style={{height: '92%'}}
            >
              {/* begin::Wrapper */}
              {/* <div className='w-100 px-5 pt-11 px-md-20 pt-md-15 pb-md-12 card card-stretch mb-8'> */}
              <div
                className='w-100 bg-white rounded-2 position-relative'
                style={{
                  height: path === '/public-request-file' ? '100%' : '100%',
                  overflow: 'hidden',
                }}
              >
                <Outlet />
              </div>
              {/* end::Wrapper */}
              {/* begin::Footer */}

              {/* begin::Links */}
              <div className='d-md-flex flex-md-row fw-semibold text-gray-500 fs-base justify-content-md-between w-100 d-flex flex-column align-items-center py-2'>
                <p
                  className='text-gray-500 m-0'
                  dangerouslySetInnerHTML={{
                    __html: `${currentYear} &copy; ${brandingConfig.companyDetails.displayName}`,
                  }}
                />
                {(path === '/meeting-invite' ||
                  path === '/public-request-file' ||
                  path === '/public-query-details') && (
                  <div className='mt-1 d-flex flex-md-row flex-column text-center align-items-center'>
                    <span className='me-2'>{formatMessage({id: 'Powered By'})}</span>
                    {/* <Link to="/">
                    <img
                      height="24"
                      alt="Foundercrate"
                      src="https://foundercrate-public-assets.s3.ap-south-1.amazonaws.com/fc-logo-stroke.png"
                    />
                  </Link> */}
                    <a href={registrationUrl} target='_blank' rel='noreferrer'>
                      <img
                        height='48'
                        alt={brandingConfig.brandName}
                        src={brandingConfig.lightModeLogo}
                      />
                    </a>
                  </div>
                )}
                <div className='d-flex'>
                  <a
                    href={brandingConfig.termsUrl}
                    className='me-4 text-gray-500'
                    target='_blank'
                    rel='noreferrer'
                  >
                    {formatMessage({id: 'Terms of use'})}
                  </a>
                  <a
                    href={brandingConfig.privacyUrl}
                    className='text-gray-500'
                    target='_blank'
                    rel='noreferrer'
                  >
                    {formatMessage({id: 'Privacy Policy'})}
                  </a>
                </div>
              </div>
              {/* end::Links */}
            </div>
            {/* end::Footer */}
          </div>
          {/* end::Form */}

          {/* end::Body */}
        </div>
      ) : (
        <div className='row container-fluid p-0 m-0 d-flex align-items-center overflow-hidden h-md-100'>
          {brandingConfig.brandName === 'RecordsKeeper.AI' ? (
            lp === 'v1' || lp === 'v2' || lp === 'finance' ? (
              <RecordsKeeperAuthLandingPage data={FinanceData} />
            ) : lp === 'legal' ? (
              <RecordsKeeperAuthLandingPage data={LegalData} />
            ) : lp === 'gov' ? (
              <RecordsKeeperAuthLandingPage data={GovData} />
            ) : lp === 'healthcare' ? (
              <RecordsKeeperAuthLandingPage data={HealthcareData} />
            ) : (
              <AuthSwiper />
            )
          ) : lp && (lp === 'v1' || lp === 'v2') ? (
            <AuthLadingPage />
          ) : (
            <AuthSwiper />
          )}
          <div
            className={`bg-white col-md-4 order-md-2 order-1 adjuster ${
              lp === 'v1' ||
              lp === 'v2' ||
              lp === 'finance' ||
              lp === 'legal' ||
              lp === 'gov' ||
              lp === 'healthcare'
                ? isMobile
                  ? 'd-none'
                  : 'd-block'
                : ' d-block'
            }`}
            style={{
              height: '100%',
              overflow: 'auto',
              boxShadow: 'inset 20px 0px 20px 0px #00000017',
            }}
          >
            <div className='align-items-md-center d-md-flex flex-md-column justify-content-md-between h-100'>
              {/* <div className='founder-create-logo d-flex justify-content-center my-4'>
                <img
                  src={toAbsoluteUrl('/media/auth/founderCrateLogo.svg')}
                  alt='Logo'
                  height={32}
                  width={auto}
                />
              </div> */}
              <div className='founder-create-logo d-flex justify-content-center my-4'>
                <img
                  src={toAbsoluteUrl(brandingConfig.lightModeLogo)}
                  alt='Logo'
                  height={45}
                  width={auto}
                />
              </div>

              <div className='w-100'>
                <Outlet />
              </div>

              <div className='d-md-flex gap-4 flex-md-row fw-semibold text-gray-500 fs-base justify-content-md-between w-100 d-flex flex-column align-items-center mt-4'>
                <p
                  className='text-gray-500 m-0'
                  dangerouslySetInnerHTML={{
                    __html: `&copy; ${currentYear} ${brandingConfig.companyDetails.displayName}`,
                  }}
                />
                <div className='d-flex'>
                  <a
                    href={brandingConfig.termsUrl}
                    className='me-4 text-gray-500'
                    target='_blank'
                    rel='noreferrer'
                  >
                    {formatMessage({ id: 'Terms of use' })}
                  </a>

                  <a
                    href={brandingConfig.privacyUrl}
                    className='text-gray-500'
                    target='_blank'
                    rel='noreferrer'
                  >
                    {formatMessage({ id: 'Privacy Policy' })}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
